import LeadsPage, { COUNSELING_CONFIG } from "@/pages/LeadsPage";

export default function CounselingsPage() {
  return <LeadsPage config={COUNSELING_CONFIG} />;
}
